/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { DAYS, MONTHS, YEARS } from '../../enums/DurationUnits.mjs'
import FormField from '../../../../client/js/components/form/fields/FormField'
import { Select, SelectProps } from '@mantine/core'

export type DurationUnitFieldProps = Omit<SelectProps, 'data'>

function DurationUnitField (props: DurationUnitFieldProps) {
  const {
    name = 'durationUnit',
    ...others
  } = props
  const intl = useIntl()
  return (
    <FormField
      name={name}
      label={intl.formatMessage({
        id: 'unit',
        defaultMessage: 'Unité'
      })}
      render={Select}
      data={[
        {
          value: DAYS,
          label: intl.formatMessage({
            id: 'days',
            defaultMessage: 'Jours'
          })
        },
        {
          value: MONTHS,
          label: intl.formatMessage({
            id: 'months',
            defaultMessage: 'Mois'
          })
        },
        {
          value: YEARS,
          label: intl.formatMessage({
            id: 'years',
            defaultMessage: 'Années'
          })
        }
      ]}
      {...others}
    />
  )
}

export default DurationUnitField
